<template>
    <div class="faq faq__wrapper">
        <component
            :is="isCategory ? 'FAQCategory' : 'FAQArticle'"
            :node-data="nodeData"
        />
        <div
            v-if="isNotRootPage"
        >
            <FAQFeedbackButton v-if="!isMeyaButtonShown" />
            <FAQMeyaButton v-if="isMeyaButtonShown" />
        </div>
    </div>
</template>

<script>
import FAQCategory from '@components/FAQCategory';
import FAQArticle from '@components/FAQArticle';
import FAQFeedbackButton from '@components/FAQFeedbackButton';
import FAQMeyaButton from '@components/FAQMeyaButton';
import { getNode as getFaqTreeNode } from '@/helpers/faqTree/getNode';
import { mapState, mapMutations } from 'vuex';
import queryString from 'query-string';
import { isMeyaSplit, isMeyaHWMGame } from '@/helpers/meyaHandler';
import supportMeyaVariant from '@/helpers/meyaHandler';

export default {
    name: 'QuestionItem',
    components: {
        FAQCategory,
        FAQArticle,
        FAQFeedbackButton,
        FAQMeyaButton,
    },
    beforeRouteEnter(to, from, next) {
        const nodeData = getFaqTreeNode('fullPath', to.fullPath)
        if (!nodeData) {
            next({ name: '404' })
            return;
        }
        next(vm => {
            vm.nodeData = nodeData
        })
    },
    beforeRouteUpdate(to) {
        const nodeData = getFaqTreeNode('fullPath', to.fullPath)
        if (!nodeData) {
            this.$router.push({ name: '404' })
            return;
        }
        this.nodeData = nodeData;
    },
    data: () => ({
        nodeData: {},
    }),
    computed: {
        ...mapState({
            urlParams: state => state.urlParams,
        }),
        isCategory() {
            return this.nodeData.type === 'article-categories';
        },
        isNotRootPage() {
            return !(this.nodeData.isRoot === true);
        },
        isMeyaButtonShown() {
            const isSupportHardMeyaType = supportMeyaVariant() === 2 || supportMeyaVariant() === 1
            return isMeyaHWMGame() && isMeyaSplit() && isSupportHardMeyaType
        },
    },
    async created() {
        if (typeof urlData!=='undefined') {
            // eslint-disable-next-line no-undef
            this.setUrlParams(urlData)
        } else {
            this.setUrlParams(queryString.parse(window.location.search))
        }
        this.setQueryParams(this.urlParams)
    },
    methods: {
        ...mapMutations({
            setUrlParams: 'setUrlParams',
            setQueryParams: 'setQueryParams',
        }),
    }
}
</script>
